import { render, staticRenderFns } from "./DesarrolloProfesional.vue?vue&type=template&id=020c653d&scoped=true"
import script from "./DesarrolloProfesional.vue?vue&type=script&lang=js"
export * from "./DesarrolloProfesional.vue?vue&type=script&lang=js"
import style0 from "./DesarrolloProfesional.vue?vue&type=style&index=0&id=020c653d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020c653d",
  null
  
)

export default component.exports